// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"281":"1a34200d","777":"e83929f0"}[chunkId] + ".css";
};